// Simple utility to merge classnames
export const cn = (...classes) => classes.filter(Boolean).join(' ');
